import { useTheme } from '@mui/material'

import { GolfItemColor, GolfItemValue, GolfKeyAndValue, GolfScoreLegendContainer } from './styles'

export const GolfHoleByHoleLegend = () => {
  const theme = useTheme()

  const items = [
    { value: 'Eagle or Better', color: theme.palette.golfColours.eagle },
    { value: 'Birdie', color: theme.palette.golfColours.birdie },
    { value: 'Bogey', color: theme.palette.golfColours.bogey },
    { value: 'Double Bogey +', color: theme.palette.golfColours.doubleBogey }
  ]

  return (
    <GolfScoreLegendContainer>
      {items.map((item, index) => (
        <GolfKeyAndValue key={index}>
          <GolfItemColor background={item.color} />
          <GolfItemValue>{item.value}</GolfItemValue>
        </GolfKeyAndValue>
      ))}
    </GolfScoreLegendContainer>
  )
}
